import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import { tab } from "@testing-library/user-event/dist/tab";
import FormatDecimal from "../../helpers/FormatDecimal";


function InvoicePrepere(props)
{

    
    
    const [view, setView] = useState('btn'); 
    const [row, setRow] = useState( [] );

    const [loaded,setLoaded] = useState(0); // 1- pobieram, 2 - pobrane..

    const [isStarted, setIsStarted] = useState(0);
    const [isClosable, setIsCloseable] = useState(1);

    const [info,setInfo] = useState("");
  
 
     const valChangeListener = (filedName, val, correct, msg) => {                         
        
               
            } 

     
    const getTab = () => {

        
        props.mainView.showProgress();

        var req = {
                                              
        }



        fetch( Config.master + '/rest_v1_calc,invoice_prepere', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => { closeDlg(); });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => { closeDlg(); } );  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                                setLoaded(2);
                                setRow(res.result);
 
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "error" ,  (resp) => { closeDlg(); });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { closeDlg(); } );
                   props.mainView.hideProgress();
         });
               

    }        


    const goPrepereById = (inx, docId, info) => {


        setInfo("Przetwarzam: " + info);
       

        props.mainView.showProgress();

        var req = {
            docId: docId,                                                          
        }



        fetch( Config.master + '/rest_v1_calc,temp_create', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    setInfo("Kończenie: " + info);

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => { closeDlg(); });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => { closeDlg(); } );  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                       

                            for(var k=0;k<row.length; k++)
                                {
                                    if(row[k].status == 1 && row[k].inx == inx) //na gotowe..
                                    {                                        
                                        row[k].status = 2; //gotowe
                                        if(props.onSuccess != undefined) props.onSuccess();

                                        setInfo("Gotowe: " + info);
                                        break;
                                    }
                                }                        
                                setRow( JSON.parse( JSON.stringify(row) ) );
                                goCreate();
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Wystąpił problem (' + JSON.stringify(res.result) + ')' , "error" ,  (resp) => { closeDlg(); });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { closeDlg(); } );
                   props.mainView.hideProgress();
         });
                   

         return false;

    }


    


    const goCreate = () => {



        //znajdz kolejne ID oczekujace na wystawienie...
        var findId = -1;
        var docId = -1;
        var info = "";

        for(var k=0;k<row.length; k++)
        {
            if(   (row[k].status == 0 || row[k].status == undefined) && row[k].selected == '1'  ) //oczekuje..
            {
                findId = row[k].inx; 
                docId = row[k].docId; 
                info = row[k].klient.nazwa + ", " + row[k].numer_umowy; 
                row[k].status = 1; //ustaw czekaj...
                break;
            }
        }

       // alert(findId);return;

        setRow( JSON.parse( JSON.stringify(row) ) );

        if(findId > -1)
        {
            goPrepereById(findId, docId, info);
        }else 
        {
            setIsCloseable(1);
            setInfo("Zakończono");
        }

    }

    const startX = () => {

        if(isStarted == 1) return;

        setIsStarted(1);
        setIsCloseable(0);
        goCreate();
    }
    

 

    const showDlg = () => {
    
         setView("dlg");   
         setInfo('');
         setLoaded(0);
    }     

    const closeDlg = () => {
        setView("btn");  
        setInfo('');
        setIsStarted(0); 
        setLoaded(0);
   }  
 




   
//-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var inx    = e.target.getAttribute('atr-inx');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<row.length; k++)
    {
        if(row[k].inx == inx)  row[k].selected = selected;
    }

    setRow(  JSON.parse(JSON.stringify(row) ) );    
}

const changeSelectedAll = (e) => {

    var s = row[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<row.length; k++)
        {
          row[k].selected = s;
        }
    
        setRow(  JSON.parse(JSON.stringify(row) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------


   


    if(loaded == 0 && view != 'btn' )
    {
        setLoaded(1);
        setRow([]);        
        getTab();
    }



    var zaznaczonych = 0; 
    for(var s=0; s<row.length; s++)
    {
        if(row[s].selected == 1) 
        {
            zaznaczonych ++;                      
        }
    }
    



    var gotowych = 0;

    for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 2) //oczekuje..
            {
                gotowych++;
            }
        }

    var proc =  parseInt( (100 * gotowych) / zaznaczonych);
    
    if(zaznaczonych == 0) proc = 0;


    


    var dlg_view =  (

            <div className="dlg_window  dlg_type_x shadowx">

                    <div className="dlg_title">
                        
                        {
                            loaded == 1 &&
                            <span>Proszę czekaj, tworzę listę...</span>
                        }

                        {
                            loaded == 2 &&
                            <span>Lista dokumentów do utworzenia</span>
                        }
                    </div>


                    <div className="dlg_content_x ">


                                  
 

                                    <div className="form_tab">

                                    <div>
                                            {
                                                row.length > 3 &&
                                                   <span onClick={changeSelectedAll} className="link_normal">zaznacz wszystkich </span>
                                            }

                                            &nbsp; &nbsp;

                                            Gotowych do utworzenia: &nbsp;
                                            {
                                                loaded == 1 &&
                                                <span>czekaj...</span>
                                            }

                                            {
                                                loaded == 2 &&
                                                <span> {row.length} </span>
                                            }

                                            {
                                                zaznaczonych != 0 &&
                                                <span> &nbsp; (wybrano: {zaznaczonych})</span>
                                            }
                                    </div>
                               
 
                                    <div className="bg_center scroll300 nostick">                                            

                                            <table className="table" >
                                                    <thead>
                                                    <tr className="header">                                                                                  
                                                        <td className="td_left">LP</td>                                                                                                                                
                                                        <td className="link_normal" onClick={changeSelectedAll}>Z</td>                                                                                                                                
                                                        <td>Klient</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Umowa</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Okres</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Info</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td className="td_right">Status</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.map( (item, ix) => {

                                                            var st = item.status;
                                                            if(item.status == 0 || item.status == undefined ) st = "oczekuje na wyst.";
                                                            if(item.status == 1) st = "Czekaj...";
                                                            if(item.status == 2) st = "Gotowe!";
                                                            if(item.status == 3) st = "Błąd!";

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            var isChecked = "";
                                                            
                                                            if(item.selected == "1" )  isChecked = "checked";
                                                             

                                                            return <tr className={ rowStyle }>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                
                                                                <td className="gocenter">
                                                                    <input type="checkbox" atr-uq={item.uq} atr-inx={item.inx} onChange={changeSelected} checked={isChecked} />
                                                                </td>                                                                                                                                
                                                                <td className="goleft">[{item.nowy}] {item.klient.nazwa}</td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter">{item.numer_umowy}</td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter">{item.okres_od} / {item.okres_do}</td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter">  

                                                                    <table>
                                                                        <tbody>
                                                                            {
                                                                                item.det.map(  (dd, inxDd) => {

                                                                                        return <tr key={inxDd} className="nobg">
                                                                                            <td>{dd.nazwa}</td>
                                                                                            <td className="goright"><FormatDecimal value={dd.netto}/></td>
                                                                                            <td className="goright"><FormatDecimal value={dd.stawka}/></td>
                                                                                            <td className="goright"><FormatDecimal value={dd.brutto}/></td>
                                                                                        </tr>

                                                                                } )
                                                                            }
                                                                        </tbody>
                                                                    </table>

                                                                 </td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter" >{st}</td>  
                                                            </tr>
                                                        })

                                                    }
                                                </tbody>
                                            </table>

                                        </div>
  

                                    
                                        <div className="form_split"></div>

                                                 {
                                                    row.length != 0 &&
                                                    <div className="progressBarZip"> 
                                                        <div className="progressLineZip" style={{ "width": proc+"%" }} > </div>  
                                                    </div> 
                                                 }       
                                                          

                                        <div className="form_split"></div>

                                        {
                                            info.length > 1 &&
                                            <Fragment>
                                                   <div className="form_split"></div>
                                                   <div>{info}</div>
                                                   <div className="form_split"></div>
                                            </Fragment>
                                        }
                                  
                                                 <br/>

                                        <div className="form_control">      

                                           

                                            {
                                                isStarted == 0 && row.length > 0 &&
                                                <Fragment>                                                    
                                                     <div className="btn" onClick={startX}>utwórz szablony</div>                                                  
                                                </Fragment>                                                
                                            }                                                                                  
                                            &nbsp; &nbsp;
                                            {
                                                (isClosable == 1 || row.length == 0 ) &&
                                                <div className="btn" onClick={closeDlg}>zamknij</div>
                                            }  

                                                                                  
                                        </div>

                                       
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;



    return  <React.Fragment>
                <div className="btn btn_extra"    onClick={showDlg} >Utwórz wg. umów</div> 
                {dlg_view} 
           </React.Fragment>
}


export default InvoicePrepere;